// removed by extract-text-webpack-plugin
module.exports = {"container":"ElnLk","overlay":"_3b3sX"};


//////////////////
// WEBPACK FOOTER
// ./app/components/profile-cover/profile-cover.scss
// module id = 1757
// module chunks = 0